import { MouseEventHandler } from "react";

import { IoAppsOutline } from "react-icons/io5";

import { ComponentWithAs, IconProps } from "@chakra-ui/react";

import {
  ConfigurationIcon,
  DocumentationIcon,
  HelpIcon,
  LogoutIcon,
  SettingsIcon,
  TerminalIcon,
} from "@/components/shared/ReleaseIcons";

export const releaseTopNavMenuItems = [
  {
    label: "Applications",
    icon: IoAppsOutline as ComponentWithAs<"svg", IconProps>,
    slug: "applications",
    pathname: "/workspaces/[workspaceId]/applications",
  },
  {
    label: "Configuration",
    icon: ConfigurationIcon,
    slug: "configuration",
    pathname: "/workspaces/[workspaceId]/configuration/cloud_integrations",
  },
  {
    label: "Agents",
    icon: TerminalIcon,
    slug: "agents",
    pathname: "/workspaces/[workspaceId]/agents/quickstart",
  },
] as const;

const helpHandler: MouseEventHandler = event => {
  event.preventDefault();
  window.$unthread.inAppChat("start");
};

export const releaseBottomNavMenuItems = [
  {
    label: "Settings",
    icon: SettingsIcon,
    slug: "settings",
    pathname: "/workspaces/[workspaceId]/settings/details",
  },
  {
    label: "Documentation",
    icon: DocumentationIcon,
    slug: "documentation",
    pathname: "https://docs.release.com",
    external: true,
  },
  {
    label: "Help",
    icon: HelpIcon,
    slug: "help",
    pathname: "#",
    onClick: helpHandler,
  },
  { label: "Log out", icon: LogoutIcon, slug: "logout", pathname: "/logout" },
] as const;

const allItems = [...releaseTopNavMenuItems, ...releaseBottomNavMenuItems] as const;
export type ReleaseNavMenuItemSlug =
  | (typeof allItems)[number]["slug"]
  | "delivery"
  | "subscription"
  | "dashboard";
